import React from "react";
import classnames from "classnames";
import Styles from "./LeadershipTeam.module.scss";
import A from "@vahak/core/dist/components/app-anchor/A";
import OnScrollFadeIn from "@vahak/core/dist/components/onscrollfadein/OnScrollFadeIn";
import LinkedinIcon from "@vahak/core/dist/icons/linkedinIconWhite.svg";
import AppImg from "components/utils/AppImg";

const leadershipTeam = [
    {
        id: 0,
        profileImgLarge: `KaranDesktop.jpg`,
        profileImgSmall: `KaranDesktop.jpg`,
        name: "Karan Shaha",
        jobTitle: "Co-founder & CEO",
        linkedinLink: "https://www.linkedin.com/in/karan-shaha-aba4b9101/"
    },
    {
        id: 1,
        profileImgLarge: `Vikas.png`,
        profileImgSmall: `Vikas-Mobile.png`,
        name: "Vikas Chandrawat",
        jobTitle: "Co-founder & CPO",
        linkedinLink: "https://www.linkedin.com/in/vikas-chandrawat/"
    },
    {
        id: 2,
        profileImgLarge: `vinay-pic-website.jpeg`,
        profileImgSmall: `vinay-pic-website.jpeg`,
        name: "Vinay Chitlangia",
        jobTitle: "VP - Technology",
        linkedinLink: "https://www.linkedin.com/in/vchitlangia"
    },
    {
        id: 3,
        profileImgLarge: `vineet-pic-website.jpeg`,
        profileImgSmall: `vineet-pic-website.jpeg`,
        name: "Vineet Sinha",
        jobTitle: "Head of Data Science",
        linkedinLink: "https://www.linkedin.com/in/vineet-sinha9"
    },
    {
        id: 4,
        profileImg: `Prashant.png`,
        profileImgLarge: `Prashant-Desktop.png`,
        profileImgSmall: `Prashant-Mobile.png`,
        name: "Prashaant Mahagaonkar",
        jobTitle: "Chief People Officer",
        linkedinLink: "https://www.linkedin.com/in/prashaant-mahagaonkar-01333319/"
    }
];

interface LeadershipTeamProps {
    isMobile: boolean;
}

const LeadershipTeam = ({ isMobile }: LeadershipTeamProps) => {
    return (
        <section className={classnames(Styles.leadershipTeamSection, "flipAnimate")}>
            <div className="container">
                <div className={Styles.heading}>
                    <h2>
                        Meet our{" "}
                        <span data-hover="Leadership Team" className="indaiText">
                            Leadership Team
                        </span>
                    </h2>
                </div>

                <div className={Styles.ourTeamRow}>
                    {leadershipTeam.map((leadership) => (
                        <div key={leadership.id} className={Styles.ourTeamCol}>
                            <OnScrollFadeIn>
                                <div className={Styles.ourTeamCard}>
                                    <A openInNewTab href={leadership.linkedinLink}>
                                        <div
                                            className={Styles.imageBox}
                                            style={
                                                {
                                                    // position: "relative"
                                                    // width: "100%"
                                                    // objectFit: "cover"
                                                    // objectPosition: "top",
                                                    // display: "block"
                                                }
                                            }
                                        >
                                            <AppImg
                                                src={leadership.profileImgLarge}
                                                alt={leadership.name}
                                                width={isMobile ? "365" : "360"}
                                                height={isMobile ? "340" : "440"}
                                                layout="responsive"
                                                objectFit="cover"
                                                objectPosition="top"
                                            />
                                        </div>
                                        <div className={Styles.textBox}>
                                            <div className={Styles.nameTitle}>
                                                <h4>{leadership.name}</h4>
                                                <p>{leadership.jobTitle}</p>
                                            </div>
                                            <span className={Styles.linkedIn}>
                                                <LinkedinIcon width="26" height="26" />
                                            </span>
                                        </div>
                                    </A>
                                </div>
                            </OnScrollFadeIn>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LeadershipTeam;
